<div class="container mt-4">
  <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
    <h4 class="mb-0">Manage Projects</h4>
    <button type="button" class="btn btn-outline-primary" (click)="goToProjectFromLesson()">
      New project from lesson
    </button>
  </div>

  <!-- Add Project Form -->
  <div class="card p-4 mb-4">
    <h5>Add New Project</h5>
    <form (ngSubmit)="addProject()">
      <div class="row">
        <div class="col-md-4 mb-3">
          <label>Project Short Code</label>
          <input type="text" [(ngModel)]="newProject.ProjectShortCode" name="shortCode" class="form-control" required />
        </div>
        <div class="col-md-4 mb-3">
          <label>Project Name</label>
          <input type="text" [(ngModel)]="newProject.ProjectName" name="name" class="form-control" required />
        </div>
        <div class="col-md-4 mb-3">
          <label>Status</label>
          <select [(ngModel)]="newProject.ProjectStatus" name="status" class="form-control">
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div class="row">


        <div class="col-md-4 mb-3">
          <label>Customer</label>
          <select [(ngModel)]="newProject.CustomerShortCode" name="customer" class="form-control">
            <option *ngFor="let customer of customers" [value]="customer.CustomerShortCode">{{
              customer.CustomerShortCode }}</option>
          </select>
        </div>
      </div>
      <button class="btn btn-primary" type="submit">Add Project</button>
    </form>
  </div>

  <!-- Filter Section -->
  <div class="card p-3 mb-3">
    <div class="row">
      <div class="col-md-3">
        <label>Status Filter</label>
        <select class="form-control" [(ngModel)]="filterDtls.status" (change)="loadProjects()">
          <option value="">All</option>
          <option>A</option>
          <option>I</option>
        </select>
      </div>
      <div class="col-md-3">
        <label>Customer Filter</label>
        <select class="form-control" [(ngModel)]="filterDtls.customerCode" (change)="loadProjects()">
          <option value="">All</option>
          <option *ngFor="let customer of customers" [value]="customer.CustomerShortCode">{{ customer.CustomerShortCode
            }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Project List -->
  <div class="card p-3">
    <h5>Project List</h5>
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>Short Code</th>
          <th>Name</th>
          <th>Status</th>
          <th>Customer</th>
          <th>Status-change</th>
          <th>Customer-change</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let project of projectList">
          <td>{{ project.ProjectShortCode }}</td>
          <td>{{ project.ProjectName }}</td>
          <td>{{ project.ProjectStatus }}</td>
          <td>{{ project.CustomerShortCode }}</td>
          <td>
            <select [(ngModel)]="project.ProjectStatus" (change)="updateProjectStatus(project)">
              <option>A</option>
              <option>I</option>
            </select>
          </td>
          <td>
            <select [(ngModel)]="project.CustomerShortCode" (change)="updateProjectCustomer(project)">
              <option *ngFor="let customer of customers" [value]="customer.CustomerShortCode">{{
                customer.CustomerShortCode }}</option>
            </select>
          </td>
          <td>
            <div class="mb-3">
              <button type="button" class="btn btn-outline-primary" (click)="Edit_Params(project)">Edit Params</button>
            </div>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>